(() => {
  const slug = (value = '') => value.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const materialFor = (style, color) => {
    const c = slug(color);
    if (style === 'everyday') {
      if (c.includes('heather-prism-blue')) return '90% Airlume cotton / 10% polyester';
      if (c.includes('heather-prism')) return '99% Airlume cotton / 1% polyester';
      if (c.includes('athletic-heather') || c.includes('black-heather')) return '90% Airlume cotton / 10% polyester';
      return '52% Airlume cotton / 48% polyester';
    }
    if (style === 'performance') {
      if (c.includes('black-heather')) return '70% Airlume cotton / 15% polyester / 15% rayon';
      return '50% polyester / 25% Airlume cotton / 25% rayon';
    }
    if (style === 'crop') {
      if (c.includes('athletic-heather')) return '90% Airlume cotton / 10% polyester';
      return '52% Airlume cotton / 48% polyester';
    }
    return '';
  };
  const selectedColor = () => {
    const checked = document.querySelector('.boop-color-picker input[type="radio"]:checked');
    return checked?.value || checked?.getAttribute('data-option-value') || '';
  };
  const refreshMaterials = () => {
    const color = selectedColor();
    document.querySelectorAll('[data-boop-fit-guide]').forEach(guide => {
      // Only personalize the garment the customer is actually viewing. Other tabs
      // remain manufacturer-default references so a color from one garment never
      // implies the same color/blend exists in another style.
      const style = guide.dataset.activeStyle;
      const target = guide.querySelector(`[data-material-style="${style}"]`);
      if (target && ['everyday','performance','crop'].includes(style)) target.textContent = materialFor(style, color);

      const note = guide.querySelector(`[data-material-note="${style}"]`);
      if (note) {
        const c = slug(color);
        const isEverydayException = style === 'everyday' && (c.includes('athletic-heather') || c.includes('black-heather') || c.includes('heather-prism'));
        const isCropException = style === 'crop' && c.includes('athletic-heather');
        note.textContent = (isEverydayException || isCropException)
          ? 'This selected color uses a different blend than most colors. See color details below.'
          : 'Most current Boop colors use this blend. See color exceptions below.';
      }
    });
  };
  const openFitAccordion = (target, scroll = true) => {
    if (!target) return;
    const details = target.querySelector('details');
    if (details) details.open = true;
    if (scroll) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  const openFitAccordionFromHash = (scroll = true) => {
    if (!location.hash.startsWith('#BoopFitGuide-')) return;
    const id = location.hash.slice(1);
    openFitAccordion(document.getElementById(id), scroll);
  };
  const init = () => {
    document.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#BoopFitGuide-"]');
      if (!link) return;
      const id = link.getAttribute('href').slice(1);
      window.setTimeout(() => openFitAccordion(document.getElementById(id)), 0);
    });
    openFitAccordionFromHash(false);
    document.querySelectorAll('[data-boop-fit-guide]').forEach(guide => {
      guide.querySelectorAll('[data-fit-tab]').forEach(tab => tab.addEventListener('click', () => {
        const style = tab.dataset.fitTab;
        guide.querySelectorAll('[data-fit-tab]').forEach(t => t.setAttribute('aria-selected', t === tab ? 'true' : 'false'));
        guide.querySelectorAll('[data-fit-panel]').forEach(panel => panel.hidden = panel.dataset.fitPanel !== style);
      }));
    });
    document.addEventListener('change', event => { if (event.target.closest('.boop-color-picker')) refreshMaterials(); });
    refreshMaterials();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
